import styled from 'styled-components';

export const CarouselSliderWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    cursor: pointer;
    position: relative;
  `,
);

export const CarouselSliderInnerWrap = styled.ul(
  props => `
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    justify-content: ${props.justifyContentProp}};
    li {
      width: 28.5rem;
      height: 19rem;
      display: flex;
      margin-right: 1rem;
      background-color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.xxxlarge};
      flex-direction: column;
    }
  `,
);

export const CabImagesContainer = styled.div`
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: solid 1px #f5f5f5;
`;

export const InfoContainer = styled.div`
    font-size: 12px;
    color: #141823;
    background-color: #fef8e5;
    padding: 0.8rem;
    margin-top: 0.8rem;
`;

export const ImageCategoryContainer = styled.div`
    display: flex;
    margin: 2rem 0 0.8rem;
    border-bottom: solid 1px #f5f5f5;
    .tab {
      font-size: 12px;
      color: #4f525a;
      padding: 0.4rem 0.8rem;
      margin-right: 0.8rem;
      cursor: pointer;
    }
    .activeTab {
      color: #141823;
      font-weight: 600;
    }
    .activeBar {
      height: 4px;
      border-radius: 2px;
      background-color: #2276e3;
    }
`;

export const SliderImg = styled.img(
  props => `
    width: 28.5rem;
    height: 19rem;
    display: flex;
    object-fit: cover;
  `,
);

export const SliderArrow = styled.button(
  props => `
      width: 4rem;
      height: 4rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      outline: 0;
      &.right {
        top: 50%;
        right: -1rem;
        transform: translateY(-50%);
      }
      &.left {
        top: 50%;
        left: -1rem;
        transform: translateY(-50%);
      }
    `,
);

